
































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import CreateRateSourceRequest from '@/models/Products/RateSources/CreateRateSourceRequest';
import PageNames from '@/router/PageNames';
import RateSource from '@/models/Products/RateSources/RateSource';

@Component({ name: 'RateSourceCreate' })
export default class extends SaascadaVueDialog {

    request: CreateRateSourceRequest = new CreateRateSourceRequest();
    rateAsString: string = '';

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.rateAsString = '';
            await RateSourceModule.getRateSourcesForDialog();
        }
    }

    get baseRateSourceOptions() {
        // Get all rate sources where baseRate is set to true
        return RateSourceModule.rateSourcesForDialog.filter((rateSource: RateSource) => (rateSource.baseRate));
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Parse the rate into a float and then create the rate source
            this.request.rate = parseFloat(this.rateAsString);
            await RateSourceModule.createRateSource(this.request);

            if (RateSourceModule.newRateSourceId != null) {
                this.$router.push({ name: PageNames.RateSource, params: { id: RateSourceModule.newRateSourceId } });
            }
        }
    }

}
